export default __webpack_public_path__ + "static/media/RTR2004V_LateralDer.e1fb7332.webp";